const state = {
    projectCosts: [], // List of project costs
    projectCost: null, // Single project cost
    loading: false,
};

export default state;
